import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';
import commonStyles from '@styles/common.module.css';

function Checkbox(props) {
  return (
    <input
      type='checkbox'
      checked={props.value}
      disabled={props.disabled}
      className={`${styles.checkbox} ${commonStyles.font} ${props.className ||
        ''}`}
      onChange={event => props.onChange(event.target.checked)}
    />
  );
}

Checkbox.defaultProps = {
  onChange: () => null,
  disabled: false,
  value: false,
};

Checkbox.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Checkbox;
